import {Auftragsverwaltung} from "../../../stores/auftragsverwaltung-mobx";
import {observer} from "mobx-react";
import {Component} from "react";
import {Button} from "semantic-ui-react";
import * as React from "react";
import {Icon} from "../../../core/components/icon/icon";
import {Popup} from "../../../core/components/popup/popup";
import {UiState} from "../../../core/ui-state";

import "./map-buttons.scss";
import {AppState} from "../app-mobx";
import {EditToggleButton} from "./edit-toggle-button";
import {MapToggleButton} from "./map-toggle-button";

export interface MapButtonsProps {
    auftragsverwaltung: Auftragsverwaltung;
    appStore: AppState;
    featureGraphic?: __esri.Graphic;
    uiStore: UiState;
    view: __esri.MapView | __esri.SceneView | undefined;
}

@observer
export class MapButtons extends Component<MapButtonsProps, any> {

    constructor(props: MapButtonsProps) {
        super(props);
        this.state = {};
        this.handleToggleMap = this.handleToggleMap.bind(this);
        this.handleZoomInClick = this.handleZoomInClick.bind(this);
    }

    componentDidMount(): void {}

    componentWillUnmount(): void {}

    render(): React.ReactElement | null {
        const {
            auftragsverwaltung, appStore, featureGraphic
        } = this.props;

        return (
            <div className={"geo-map-buttons"}>
                <MapToggleButton auftragsverwaltung={auftragsverwaltung} appStore={appStore} />
                <EditToggleButton auftragsverwaltung={auftragsverwaltung} />
                {featureGraphic && auftragsverwaltung.showMap &&
                    <Button className={"zoom"} secondary
                        onClick={(e: React.MouseEvent) => {
                            this.handleZoomInClick(e);
                        }}>
                        <Icon name={"zoom_in"} selected /> Zoomen
                    </Button>
                }
            </div>
        );
    }

    private handleZoomInClick(e: React.MouseEvent): void {
        const {view, uiStore, auftragsverwaltung, featureGraphic} = this.props;
        const {showMap} = auftragsverwaltung;
        if (featureGraphic && typeof view !== "undefined") {
            const popup = uiStore.widgets.get("popup") as Popup;
            if (popup) {
                popup.close();
            }
            if (!showMap) {
                auftragsverwaltung.setShowMap(true);
            }
            view.goTo(featureGraphic).catch((error) => {
                if (error.name !== "view:goto-interrupted") {
                    // eslint-disable-next-line no-console
                    console.error(error);
                }
            });
            e.preventDefault();
            // Wenn blur direkt via e.target aufgerufen wird, reklamiert Webstorm:
            // TS2339: Property 'blur' does not exist on type 'EventTarget'.
            const target = e.target as HTMLElement;
            target.blur();
        }
    }
    private handleToggleMap(e: React.MouseEvent): void {
        const {auftragsverwaltung} = this.props;
        const {showMap} = auftragsverwaltung;
        auftragsverwaltung.setShowMap(!showMap);
        e.preventDefault();
        const target = e.target as HTMLElement;
        target.blur();
    }
}
